import React from 'react'
import { Globe } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { supportedLanguages, languageNames, SupportedLanguage } from '../i18n'

interface LanguageSwitcherProps {
  className?: string
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className = '',
}) => {
  const { i18n, t } = useTranslation()
  const [isOpen, setIsOpen] = React.useState(false)

  const currentLanguage = (i18n.language || 'en') as SupportedLanguage

  const handleLanguageChange = async (lang: SupportedLanguage) => {
    await i18n.changeLanguage(lang)
    setIsOpen(false)
  }

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium text-gray-300 hover:bg-gray-800 transition-colors"
        aria-label={t('common.language')}
      >
        <Globe className="w-4 h-4" />
        <span>{languageNames[currentLanguage]}</span>
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Dropdown */}
          <div className="absolute bottom-full mb-1 start-0 z-20 min-w-[140px] bg-gray-800 rounded-lg shadow-lg border border-gray-700 py-1">
            {supportedLanguages.map((lang) => (
              <button
                key={lang}
                onClick={() => handleLanguageChange(lang)}
                className={`w-full px-4 py-2 text-start text-sm transition-colors ${
                  currentLanguage === lang
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
              >
                {languageNames[lang]}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
